import {MathUtils, Utils} from '@astek/utils';

export class Measurement {

  constructor(
    public readonly timestamp: number,
    public readonly rawPressure: number,
    public readonly meanPressure: number | null = null,
  ) {
    this.checkValue(this.timestamp, 'Timestamp');
    this.checkValue(this.rawPressure, 'Raw pressure');
    if (Utils.isNotNullOrUndefined(this.meanPressure)) {
      this.checkValue(this.rawPressure, 'Mean pressure');
    }
  }

  public equals(other: Measurement): boolean {
    return this.timestamp === other.timestamp
      && MathUtils.fuzzyEquals(this.rawPressure, other.rawPressure)
      && ((Utils.isNullOrUndefined(this.meanPressure) && Utils.isNullOrUndefined(other.meanPressure))
        || (Utils.isNotNullOrUndefined(this.meanPressure) && Utils.isNotNullOrUndefined(other.meanPressure)
          && MathUtils.fuzzyEquals(this.meanPressure, other.meanPressure)));
  }

  private checkValue(value: number, name: string): void {
    if (Number.isNaN(value)) {
      throw new Error(name + ' cannot be NaN');
    }
    if (!Number.isFinite(value)) {
      throw new Error(name + ' must be finite');
    }
  }

}
